import { jsx as _jsx } from "react/jsx-runtime";
import { GraphQLClientProvider } from '@dixa/lib-integrations-partner-widgets';
import { config } from 'lib-shared-backend-config';
import { FormProvider as OAuthFormProvider, useForm } from 'react-hook-form';
/** Represents the provider for OAuth. */
export const OAuthProvider = ({ children }) => {
    const oAuthForm = useForm({
        defaultValues: {
            id: '',
            name: '',
        },
        mode: 'onTouched',
    });
    return (_jsx(GraphQLClientProvider, Object.assign({ configuration: { baseUrl: config.url.partnerIntegrations } }, { children: _jsx(OAuthFormProvider, Object.assign({}, oAuthForm, { children: children })) })));
};
